import { React, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
const URL = process.env.REACT_APP_API_URL;

const Instrument = [
  "Piano",
  "Guitar",
  "Singing",
  "Battery",
  "Violin",
  "Alto",
  "Cello",
  "Bass",
  "Transverse flute",
  "Oboe",
  "Clarinet",
  "Bassoon",
  "French horn",
  "Trumpet",
  "Trombone",
  "Tuba",
  "Percussion",
  "Other",
];

export default function Signup() {
  const INITIAL_STATE = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    professionalMusician: "",
    instrument: "",
  };
  const [error, setError] = useState({});
  const navigate = useNavigate();
  const [data, setData] = useState(INITIAL_STATE);
  const [showpassword, setShowPassword] = useState(false);
  const [showconfirmpassword, setShowConfirmPassword] = useState(false);

  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const phoneRegex = /^(\+33|0)[1-9](\d{2}){4}$/;

  // Validates a single field, given the full (up-to-date) form values.
  // Returns an error message string, or "" if the field is valid.
  const validateField = (name, value, allValues) => {
    switch (name) {
      case "firstName":
        if (!value.trim()) return "Le prénom est requis";
        return "";

      case "lastName":
        if (!value.trim()) return "Le nom de famille est requis";
        return "";

      case "email":
        if (!value.trim()) return "L'adresse e-mail est requise";
        if (!regex.test(value)) return "Veuillez saisir une adresse e-mail valide";
        return "";

      case "phone":
        if (!value.trim()) return "Le numéro de contact est requis";
        if (!phoneRegex.test(value)) return "Numéro invalide";
        return "";

      case "professionalMusician":
        if (!value.trim()) return "Musicien professionnel est requis";
        return "";

      case "instrument":
        if (!value.trim()) return "Instrument est requis";
        return "";

      case "password":
        if (!value.trim()) return "Le mot de passe est requis";
        if (value.trim().length < 8)
          return "Le mot de passe doit comporter 8 caractères ou plus";
        if (!/\d/.test(value))
          return "Le mot de passe doit contenir au moins 1 chiffre";
        if (!/[!@#$%&?]/.test(value))
          return "Le mot de passe doit contenir au moins 1 caractère spécial";
        if (!/[A-Z]/.test(value))
          return "Le mot de passe doit contenir au moins 1 lettre majuscule";
        return "";

      case "confirmPassword":
        if (!value.trim()) return "La confirmation du mot de passe est requise";
        if (value !== allValues.password)
          return "Les mots de passe ne correspondent pas";
        return "";

      default:
        return "";
    }
  };

  // Full-form validation, used on submit to catch every field at once.
  const validate = (values) => {
    const errors = {};
    Object.keys(INITIAL_STATE).forEach((key) => {
      const msg = validateField(key, values[key], values);
      if (msg) errors[key] = msg;
    });
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...data, [name]: value };
    setData(updatedData);

    // Validate just the field that changed.
    setError((prevErrors) => {
      const newErrors = { ...prevErrors };
      const msg = validateField(name, value, updatedData);

      if (msg) {
        newErrors[name] = msg;
      } else {
        delete newErrors[name];
      }

      // confirmPassword depends on password, so re-check it too
      // whenever password changes.
      if (name === "password" && updatedData.confirmPassword) {
        const confirmMsg = validateField(
          "confirmPassword",
          updatedData.confirmPassword,
          updatedData
        );
        if (confirmMsg) {
          newErrors.confirmPassword = confirmMsg;
        } else {
          delete newErrors.confirmPassword;
        }
      }

      return newErrors;
    });
  };

  const btnsubmit = async (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      email,
      password,
      phone,
      professionalMusician,
      instrument,
      confirmPassword,
    } = data;

    const validationErrors = validate(data);
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }

    try {
      const payload = {
        firstName,
        lastName,
        email,
        password,
        phone,
        professionalMusician,
        instrument,
        confirmPassword,
      };

      const response = await axios.post(`${URL}/api/signup`, payload);
      if (response.data === "Registered Successfully") {
        setData(INITIAL_STATE);
        toast(response.data);
        navigate("/login");
      } else {
        alert(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <form className="signup_form">
              <h3 className="form_title text-center mb-4">Créer un compte</h3>
              <div className="row">
                <div className="col-sm-6 mb-3">
                  <div className="form_field">
                    <input
                      type="text"
                      placeholder=""
                      autoComplete="off"
                      name="firstName"
                      value={data.firstName}
                      onChange={handleChange}
                      required
                      className="floating_input"
                    />
                    <label htmlFor="firstName" className="floating_label">
                      Prénom
                    </label>
                  </div>
                  {error.firstName && <small className="error-field">{error.firstName}</small>}
                </div>
                <div className="col-sm-6 mb-3">
                  <div className="form_field">
                    <input
                      type="text"
                      id="lastName"
                      placeholder=""
                      autoComplete="off"
                      name="lastName"
                      value={data.lastName}
                      onChange={handleChange}
                      required
                      className="floating_input"
                    />
                    <label htmlFor="lastName" className="floating_label">
                      Nom de famille
                    </label>
                  </div>
                  {error.lastName && <small className="error-field">{error.lastName}</small>}
                </div>
                <div className="col-sm-12 mb-3">
                  <div className="form_field">
                    <input
                      type="email"
                      id="email"
                      autoComplete="off"
                      placeholder=""
                      name="email"
                      required
                      value={data.email}
                      onChange={handleChange}
                      className="floating_input"
                    />
                    <label htmlFor="email" className="floating_label">
                      E-mail
                    </label>
                  </div>
                  {error.email && <small className="error-field">{error.email}</small>}
                </div>

                <div className="col-sm-12 mb-3">
                  <div className="form_field">
                    <input
                      type="text"
                      id="phone"
                      placeholder=" "
                      name="phone"
                      autoComplete="off"
                      required
                      value={data.phone}
                      onChange={handleChange}
                      className="floating_input"
                      onKeyPress={(event) => {
                        if (!/[0-9+]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="phone" className="floating_label">
                      Numéro de téléphone
                    </label>
                  </div>
                  {error.phone && <small className="error-field">{error.phone}</small>}
                </div>

                <div className="col-sm-6 mb-3">
                  <div className="form_field">
                    <select
                      id="professionalMusician"
                      name="professionalMusician"
                      value={data.professionalMusician}
                      onChange={handleChange}
                      className="floating_input"
                    >
                      <option value="">Musicien professionnel ? </option>
                      <option value="OUI">OUI</option>
                      <option value="NON">NON</option>
                    </select>
                  </div>
                  {error.professionalMusician && (
                    <small className="error-field">{error.professionalMusician}</small>
                  )}
                </div>
                <div className="col-sm-6 mb-3">
                  <div className="form_field">
                    <select
                      id="instrument"
                      name="instrument"
                      value={data.instrument}
                      onChange={handleChange}
                      className="floating_input"
                    >
                      <option value="">Instrument</option>
                      {Instrument.map((el) => (
                        <option key={el} value={el}>
                          {el}
                        </option>
                      ))}
                    </select>
                  </div>
                  {error.instrument && <small className="error-field">{error.instrument}</small>}
                </div>

                <div className="col-sm-12 mb-3">
                  <div className="form_field">
                    <input
                      type={showpassword ? "text" : "password"}
                      id="password"
                      placeholder=""
                      autoComplete="off"
                      name="password"
                      value={data.password}
                      onChange={handleChange}
                      required
                      className="floating_input"
                    />
                    <label htmlFor="password" className="floating_label">
                      Mot de passe
                    </label>

                    <div
                      className="field_icon"
                      onClick={() => setShowPassword(!showpassword)}
                    >
                      {showpassword ? <BsEyeFill /> : <BsEyeSlashFill />}
                    </div>
                  </div>
                  {error.password && <small className="error-field">{error.password}</small>}
                </div>

                <div className="col-sm-12 mb-3">
                  <div className="form_field">
                    <input
                      type={showconfirmpassword ? "text" : "password"}
                      id="confirmPassword"
                      placeholder=""
                      autoComplete="off"
                      name="confirmPassword"
                      value={data.confirmPassword}
                      onChange={handleChange}
                      required
                      className="floating_input"
                    />
                    <label htmlFor="confirmPassword" className="floating_label">
                      Confirmez le mot de passe
                    </label>

                    <div
                      className="field_icon"
                      onClick={() =>
                        setShowConfirmPassword(!showconfirmpassword)
                      }
                    >
                      {showconfirmpassword ? <BsEyeFill /> : <BsEyeSlashFill />}
                    </div>
                  </div>
                  {error.confirmPassword && (
                    <small className="error-field">{error.confirmPassword}</small>
                  )}
                </div>

                <div className="col-12">
                  <button
                    className="btn btn-primary w-100 form_btn"
                    onClick={btnsubmit}
                  >
                    Créer un compte
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}